import React from 'react'


export default function Video() {
  return (
    <>


<div>
        
<div className=' text-center my-5 mx-5'>
<h2 class="card-title py-2" >Our <span style={{color:"#FFD700"}}>Videos</span> </h2>

</div>

<div className=' row '>


<div class=" col mx-5 px-4 my-1">
{/* <img src="https://easydrawingguides.com/wp-content/uploads/2021/08/drum-step-by-step-drawing-tutorial-step-10.png" class="card-img-top py-5"  alt="..."/> */}
<iframe className='mt-5' src="https://www.youtube.com/embed/RP6zb5tJV8c" title="YouTube video player" frameborder="0" class="card-img-top py-5" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
<center><a href="https://youtu.be/RP6zb5tJV8c" target="_blank" class="btn btn-dark card-title my-0 mx-0">Watch in Youtube</a></center>
<div class="card-body">

<p class="card-text">Some quick example text to build on the card title and make up the bulk of the card's content.</p>

</div>
</div>

<div class=" col mx-5 px-4 my-1">
{/* <img src="https://easydrawingguides.com/wp-content/uploads/2021/08/drum-step-by-step-drawing-tutorial-step-10.png" class="card-img-top py-5"  alt="..."/> */}
<iframe className='mt-5' src="https://www.youtube.com/embed/1e_VjmLUgUA" title="YouTube video player" frameborder="0" class="card-img-top py-5" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
<center><a href="https://youtu.be/RP6zb5tJV8c" target="_blank" class="btn btn-dark card-title my-0 mx-0">Watch in Youtube</a></center>
<div class="card-body">

<p class="card-text">Some quick example text to build on the card title and make up the bulk of the card's content.</p>

</div>
</div>

<div class=" col mx-5 px-4 my-1" >
{/* <img src="https://easydrawingguides.com/wp-content/uploads/2021/08/drum-step-by-step-drawing-tutorial-step-10.png" class="card-img-top py-5"  alt="..."/> */}
<iframe className='mt-5' src="https://www.youtube.com/embed/FcL3YftehjA" title="YouTube video player" frameborder="0" class="card-img-top py-5" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
<center><a href="https://youtu.be/RP6zb5tJV8c" target="_blank" class="btn btn-dark card-title my-0 mx-0">Watch in Youtube</a></center>
<div class="card-body">

<p class="card-text">Some quick example text to build on the card title and make up the bulk of the card's content.</p>

</div>
</div>



</div>

</div>
</>

  )
}